import React, { useEffect, useState } from "react";
import MovieList from "./MovieList";
import SeeMoreBtn from "./SeeMoreBtn";
import Search from "./Search";
import axios from "axios";

import "./SideBar.scss";

const SideBar = ({ value, setValue }) => {
  const [searchText, setSearchText] = useState("");
  const [content, setContent] = useState([]);

  const fetechedMoviesList = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/trending/movie/week?api_key=${process.env.REACT_APP_API_KEY}`
    );

    // console.log(data, "comoing from Sidebar");
    setContent(data.results);
  };

  useEffect(() => {
    fetechedMoviesList();
  }, []);
  return (
    <div className="sidebar-container">
      <Search searchText={searchText} setSearchText={setSearchText} />
      <h3>Popular Movies</h3>
      <div className="sidebar-container__movielist-container">
        {content &&
          content.map((c, index) => (
            <MovieList
              movieIndex={index}
              key={c.id}
              id={c.id}
              title={c.name || c.title}
              poster={c.poster_path}
              value={value}
              setValue={setValue}
            />
          ))}
      </div>
      <SeeMoreBtn />
    </div>
  );
};
export default SideBar;
